<template lang="pug">
GenericCard.all-orders-today-list(size='auto')
  .d-flex.align-items-center.justify-content-between.p-3
    .d-flex
      .text-large รายการขายวันนี้
    CustomDatePicker(v-model='filterDate')
  hr.m-0

  LoadedContentWrapper.flex-fill(
    :isLoading='isLoading'
    :data='tableData'
    @reload='loadData'
  )
    .pt-2.pb-2.px-3
      CustomTable(
        :columns='tableCols'
        :data='tableData'
        :showIndexes='true'
        :startIndex='pageFirstRowIndex'
        @itemClicked="$emit('itemClicked', $event)"
      )

  hr.m-0
  .px-4.py-3
    CustomPagination(
      v-model='currentPage'
      :total='totalPage'
      :compact='true'
    )
</template>

<script>
import api from '@/api';

/* eslint-disable arrow-body-style */
export default {
  watch: {
    // reload data
    filterDate: {
      handler() { this.currentPage = 1; this.loadData(); },
      deep: true,
    },
    currentPage() { this.loadData(); },
  },
  data: () => ({
    isLoading: false,

    filterDate: '',

    tableCols: {
      customerName: {
        title: 'ชื่อลูกค้า',
        align: 'left',
        computed: row => (row.customer ? row.customer.name : '-'),
      },
      entryNo: {
        title: 'เลขที่รายการ',
        align: 'left',
        type: 'EntryNo',
      },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
      },
      status: {
        title: 'สถานะ',
        align: 'center',
        type: api.customer.COL_TYPE.OrderStatus,
      },
    },
    tableData: [],

    // pagination
    currentPage: 1,
    totalPage: 0,
    totalRows: 0,
    pageFirstRowIndex: 1,
  }),
  mounted() {
    this.filterDate = {
      from: this.$moment().startOf('day').toDate(),
      to: this.$moment().endOf('day').toDate(),
    };
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      try {
        const res = await this.$api.order.list(
          null, // status
          this.currentPage,
          this.filterDate.from,
          this.filterDate.to,
          // filterSearch,
          // filterArea,
        );
        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
          this.$emit('finishLoading', res.data);
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss">
.filter-date {
  font-size: 20px;
}
</style>
